import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { ListState } from ".";

const initialState: ListState = {
  title: "",
  list: [],
};

const store = proxy<ListState>({ ...initialState });

export const toolkitListActions = {
  setList(nextState: Partial<ListState>) {
    Object.assign(store, initialState, nextState);
  },
};

export function useToolkitListStore() {
  return useSnapshot(store);
}

export function getToolkitListState() {
  return snapshot(store);
}

export function resetToolkitListStore() {
  Object.assign(store, initialState);
}
